import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import type { FAQ } from "@/types/HelpArticle";

interface HelpFAQAccordionProps {
  faqs: FAQ[];
}

const HelpFAQAccordion = ({ faqs }: HelpFAQAccordionProps) => {
  if (faqs.length === 0) {
    return (
      <div className="text-center py-8 bg-gray-50 rounded-md">
        <p className="text-gray-600">No FAQs available at this time.</p>
      </div>
    );
  }

  return (
    <Accordion type="single" collapsible className="w-full bg-white rounded-md border">
      {faqs.map((faq) => (
        <AccordionItem key={faq.id} value={faq.id}>
          <AccordionTrigger className="px-4 hover:bg-gray-50">
            <span className="text-left font-medium">{faq.question}</span>
          </AccordionTrigger>
          <AccordionContent className="px-4 pb-4">
            <div className="text-gray-700 whitespace-pre-wrap">
              {faq.answer}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default HelpFAQAccordion;
